import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MAP } from 'react-google-maps/lib/constants';
import GoogleMap from 'react-google-maps/lib/components/GoogleMap';

import { iFullStoreState } from '../../../shared/interfaces';
import { Actions as GmapActions } from '../../../stores/reducers/gmap-reducers';
import { ReactComponent as MyLocationIcon } from '../../../assets/svg/my_location.svg';
import { ReactComponent as SatelliteViewIcon } from '../../../assets/svg/satellite-view.svg';
import { ReactComponent as TrafficLayerIcon } from '../../../assets/svg/traffic-lamp.svg';
import { ReactComponent as AddIcon } from '../../../assets/svg/add.svg';
import { ReactComponent as RemoveIcon } from "../../../assets/svg/remove.svg";

import { Tooltip } from '@mui/material';
import classNames from "classnames";
import styles from './styles.module.scss';


const FabMenu = () => {
    const IS_PUBLIC_VIEW = window.location.href.includes('public-view');

    return !IS_PUBLIC_VIEW ? (
        <nav className={styles.menu}>
            <ButtonToggleStreetView />
            <ButtonToggleMapType />
            <ButtonToggleTrafficLayer />
            <ZoomButtons />
        </nav>
    ) : null;
}

export default FabMenu;

const ZoomButtons = () => {
    const mapRef = useSelector<iFullStoreState, React.RefObject<GoogleMap> | null>(state => state.gmap.mapRef());

    const changeZoom = (step: number) => {
        if (mapRef?.current) {
            mapRef.current.context[MAP].setZoom(mapRef.current.getZoom() + step);
        }
    };
    const incrementZoom = () => changeZoom(1);
    const decrementZoom = () => changeZoom(-1);

    return <>
        <Tooltip title="Zoom in" placement='top'>
            <span className={styles.menuItem} onClick={incrementZoom}>
                <AddIcon />
            </span>
        </Tooltip>
        <Tooltip title="Zoom out" placement='top'>
            <span className={styles.menuItem} onClick={decrementZoom}>
                <RemoveIcon />
            </span>
        </Tooltip>
    </>;
};

const ButtonToggleMapType = () => {
    const dispatch = useDispatch();
    const isHybrid = useSelector<iFullStoreState, boolean>(s => s.gmap.mapType === google.maps.MapTypeId.HYBRID);
    const title = isHybrid ? 'Map view' : 'Satellite view';

    const toggleMapType = () => dispatch(GmapActions.TOGGLE_MAP_TYPE());

    return (
        <Tooltip title={title} placement='top'>
            <span
                className={classNames(styles.menuItem, {
                    [styles.menuItem_pressed]: isHybrid,
                })}
                onClick={toggleMapType}
            >
                <SatelliteViewIcon />
            </span>
        </Tooltip>
    );
};


const ButtonToggleStreetView = () => {
    const dispatch = useDispatch();
    const isStreetView = useSelector<iFullStoreState, boolean>(s => !!s.gmap.streetViewLocation);

    const toggleStreetView = () => dispatch(GmapActions.TOGGLE_STREET_VIEW());

    return (
        <Tooltip title='Street view' placement='top'>
            <span
                className={classNames(styles.menuItem, {
                    [styles.menuItem_pressed]: isStreetView,
                })}
                onClick={toggleStreetView}
            >
                <MyLocationIcon />
            </span>
        </Tooltip>
    );
};

const ButtonToggleTrafficLayer = () => {
    const dispatch = useDispatch();
    const isTrafficLayer = useSelector<iFullStoreState, boolean>(s => !!s.gmap.trafficLayer);

    const toggleTrafficLayer = () => dispatch(GmapActions.TOGGLE_TRAFFIC_LAYER());

    return (
        <Tooltip title='Traffic layer' placement='top'>
            <span
                className={classNames(styles.menuItem, {
                    [styles.menuItem_pressed]: isTrafficLayer,
                })}
                onClick={toggleTrafficLayer}
            >
                <TrafficLayerIcon />
            </span>
        </Tooltip>
    );
};
